import { ACTIONS } from "@/modules/main/store/globalSearchModule";
import { store } from '@/modules/main/store';
import { getPlatformSubtitle, getPlatformTitle } from '@/utils/platforms';
export function storeSearchData(search, section) {
    store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_TITLE, section === 'section-6' ? getPlatformTitle(search) : search.name);
    store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_LOGO, search.logo_path);
    store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_HEADER, search.profile_image_path);
    store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_SUBTITLE, section === 'section-6' ? getPlatformSubtitle(search) : '');
    store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_SECTION, section);
    store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_UUID, search.uuid);
}
export var searchSections = {
    'section-5': true,
    'section-6': true,
    'section-7': true,
    'section-8': true,
    'section-9': true,
    'section-10': true,
    'section-11': true,
};
